/* eslint-disable react/sort-comp */
/* eslint-disable consistent-return */
/* eslint-disable react/no-unused-state */
/* eslint-disable no-unused-vars */
import React from 'react';
import moment from 'moment';
import { map, pick, find } from 'lodash';
import { Line, Bubble, Chart } from 'react-chartjs-2';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
// not explicitly invoked, registers with chart js library itself and is used in chart options so import is necessary
// eslint-disable-next-line no-unused-vars
import ChartDataLabels from 'chartjs-plugin-datalabels';
// not explicitly invoked, registers with chart js library itself and is used in chart options so import is necessary
// eslint-disable-next-line no-unused-vars
import ChartAnnotations from 'chartjs-plugin-annotation';
import PropTypes from 'prop-types';

import TabContentBase from '../TabContentBase';
import RatingCircle from '../RatingCircle';
import RankingsV2 from './RankingsV2';
import { ScoreCard } from '../../cards';
import { getRatingDetails, setRatingChoice } from '../../../utils';
import { formatMatchDate } from '../../../utils/formatting';
import RatingTrend from './RatingTrend/ratingTrend';
import DescriptionStylable from '../../text/DescriptionStylable';
import InfoButton from '../../InfoButton';
import FilterButtons from './PlayerProfileMetrics/filterButtons';
import HowTheChartsWorkInfoPopup from '../../InfoPopUps/PlayerProfileMetrics/howTheChartsWorkInfoPopup';
import Img from '../../Img';
import withAuth from '../../hocs/withAuth';

import ActivityStats from './ActivityStats';
import PerformanceStats from './PerformanceStats';
import styles from './newStatsTabContent.scss';
import NumberStats from './NumberStats';
import TrackedClick, { trackEvent } from '../../Analytics/TrackedClick';
import { ratingTypes, gameTypes } from '../../../utils/constants';
import { getStatsData } from '../../../actions/profile-tab-actions';
import { getClickAttrs } from '../../Analytics/gtag';
import {
    clickCategories,
    profileAnalyticsEvents,
    statsAnalyticsEvents,
    statsSubtabNames,
    getAnalyticsCommonTraits,
    getActivityStatsTraits,
} from '../../../utils/analytics';
import paths from '../../../../constants/paths';

const _ = { map, pick, find };

const statsViewTypes = {
    RATING: 'rating',
    ACTIVITY: 'activity',
    PERFORMANCE: 'performance',
};

const statsSubtabNamesByView = {
    [statsViewTypes.RATING]: statsSubtabNames.RATING,
    [statsViewTypes.ACTIVITY]: statsSubtabNames.ACTIVITY,
    [statsViewTypes.PERFORMANCE]: statsSubtabNames.PERFORMANCE,
};

const buildRankingCards = (ptsRankings, rankings, statsType) => {
    const cards = [];
    if (ptsRankings?.rankings) {
        ptsRankings.rankings.forEach(rank => {
            cards.push({ ...rank, type: 'ptt', gender: ptsRankings.gender });
        });
    }
    if (statsType === 'singles' && rankings?.rankings) {
        rankings.rankings.forEach(rank => {
            cards.push({ ...rank, type: 'verified', gender: rankings.gender });
        });
    }
    return cards;
};

const resolveStatsView = ({ isActivityMetricsEnabled, isPerformanceStatsEnabled, initialStatsView }) => {
    if (isActivityMetricsEnabled && initialStatsView === statsViewTypes.ACTIVITY) {
        return statsViewTypes.ACTIVITY;
    }
    if (isPerformanceStatsEnabled && initialStatsView === statsViewTypes.PERFORMANCE) {
        return statsViewTypes.PERFORMANCE;
    }
    return statsViewTypes.RATING;
};

class NewStatsTabContent extends React.Component {
    constructor(props) {
        super(props);
        const initialView = resolveStatsView(props);
        // The enabling flags derive from async inputs (profile data, Statsig, auth), so on a
        // client-side nav this constructor can run before they resolve and a `?view=` deep link
        // would be lost for good. componentDidUpdate re-applies it once the flag lands; this
        // latch stops it firing again, or overriding a subtab the user picked themselves.
        this.hasResolvedInitialStatsView = initialView !== statsViewTypes.RATING;
        this.state = {
            chartToDisplay: 'ratingTrend',
            utrRegularFontFamily: '"Inter", Arial, sans-serif',
            utrNumeralsFontFamily: '"Big Shoulders", sans-serif',
            utrMediumGrayColor: '#738b9c',
            utrLightMagentaColor: '#e0007f',
            utrLightTealColor: '#00bab6',
            utrDarkBlueColor: '#2b3339',
            items: [],
            hasMore: true,
            activeStatsView: initialView,
        };
        // rating trend line drop shadow
        const { draw } = Chart.controllers.line.prototype;
        Chart.controllers.line = Chart.controllers.line.extend({
            draw() {
                const { ctx } = this.chart.chart;
                ctx.save();
                ctx.shadowColor = '#a5b2bb';
                ctx.shadowBlur = 20;
                ctx.shadowOffsetX = 0;
                ctx.shadowOffsetY = 10;
                ctx.stroke();
                // eslint-disable-next-line prefer-rest-params
                draw.apply(this, arguments);
                ctx.restore();
            },
        });
        // Rating Trend Chart Functions
        this.setRatingTrendChartRef = this.setRatingTrendChartRef.bind(this);
        this.getRatingTrendChartData = this.getRatingTrendChartData.bind(this);
        this.getRatingTrendChartTimeAxisLabels = this.getRatingTrendChartTimeAxisLabels.bind(this);
        this.getRatingTrendRatingsData = this.getRatingTrendRatingsData.bind(this);
        this.getRatingTrendResultsData = this.getRatingTrendResultsData.bind(this);
        this.getResultBackgroundColor = this.getResultBackgroundColor.bind(this);
        this.getResultBorderColor = this.getResultBorderColor.bind(this);
        this.getResultBorderWidth = this.getResultBorderWidth.bind(this);
        this.getResultDataLabelColor = this.getResultDataLabelColor.bind(this);
        this.getRatingTrendChartOptions = this.getRatingTrendChartOptions.bind(this);
        this.handleShowMore = this.handleShowMore.bind(this);

        // VictoryMargin Chart Functions
        this.setVictoryMarginChartRef = this.setVictoryMarginChartRef.bind(this);
        this.getVictoryMarginChartData = this.getVictoryMarginChartData.bind(this);
        this.getVictoryMarginChartOptions = this.getVictoryMarginChartOptions.bind(this);
        this.getVictoryMarginResultsData = this.getVictoryMarginResultsData.bind(this);
        this.getVictoryMarginChartRatingsAxisLabels = this.getVictoryMarginChartRatingsAxisLabels.bind(this);

        // Change from Singles to Doubles Tab
        this.handleStatsChange = this.handleStatsChange.bind(this);
        this.profilePreferredStats = this.profilePreferredStats.bind(this);
        this.handleStatsViewChange = this.handleStatsViewChange.bind(this);
    }

    componentDidMount() {
        this.profilePreferredStats(this.props);

        const { items } = this.state;
        const { profileData, profileTabData, isProfileIdUpdated } = this.props;
        const historyItems = (profileData.extendedRatingProfile && profileData.extendedRatingProfile.history) ? profileData.extendedRatingProfile.history : [];
        if (items.length === 0 && historyItems) {
            this.setState({ items: [...historyItems.slice(0, 5)] });
        }

        if (this.props.isUserLoggedIn && !profileTabData?.stats?.data && isProfileIdUpdated) {
            this.props.getPlayerStats();
        }
    }

    componentDidUpdate() {
        if (this.hasResolvedInitialStatsView) {
            return;
        }
        const resolvedView = resolveStatsView(this.props);
        if (resolvedView === statsViewTypes.RATING) {
            return;
        }
        this.hasResolvedInitialStatsView = true;
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ activeStatsView: resolvedView });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { profileData } = this.props;
        const { isProfileIdUpdated, profileTabData, isLoadingProfile, isUserLoggedIn } = nextProps;

        if (nextProps.profileData.id !== profileData.id) {
            this.profilePreferredStats(nextProps);
            // A profile-to-profile navigation reuses this instance, so the constructor does
            // not re-run. Unlatch to let the new profile's `?view=` deep link resolve.
            this.hasResolvedInitialStatsView = false;
        }
        this.setState({
            utrMediumGrayColor: '#778da9',
            utrLightMagentaColor: '#e0004f',
            utrLightTealColor: '#00C0F7',
            utrDarkBlueColor: '#008ded',
        });

        const hasNoStats = isUserLoggedIn && !profileTabData?.stats?.isLoading && !profileTabData?.stats?.data && !profileTabData?.stats?.error && isProfileIdUpdated && !isLoadingProfile;
        if (hasNoStats) {
            this.props.getPlayerStats();
        }
    }

    profilePreferredStats(props) {
        const { profileData, statsState, auth } = props;
        const isUserPowered = auth?.user?.isPowered;
        const isVerifiedDoublesUTR = profileData.ratingChoice === 'VerifiedDoublesUTR';
        const isVerifiedSinglessUTR = profileData.ratingChoice === 'VerifiedSinglesUTR';
        const isNotDoubles = statsState.type !== 'doubles';
        const isNotsingles = statsState.type !== 'singles';

        const hasProfileTabData = this.props.profileTabData;
        const hasStatsData = this.props.profileTabData?.stats?.data;
        const hasNoSinglesUtr = !this.props.profileTabData?.stats?.data?.singlesUtr;

        const isUserPoweredAndNotDoubles = isUserPowered && isVerifiedDoublesUTR && isNotDoubles;
        const isDoublesConditionMet = hasProfileTabData && hasStatsData && hasNoSinglesUtr;
        const isUserPoweredAndNotSingles = isUserPowered && isVerifiedSinglessUTR && isNotsingles;

        if (isUserPoweredAndNotSingles) {
            props.updateStatsParams({
                type: 'singles',
                fetchAllResults: true,
            });
        } else if ((isUserPoweredAndNotDoubles) || (isDoublesConditionMet)) {
            props.updateStatsParams({
                type: 'doubles',
                fetchAllResults: true,
            });
        }
    }

    // Start Rating Trend CHart Functions
    setRatingTrendChartRef(node) {
        this.ratingTrendChartRef = node;
    }

    getRatingTrendChartData() {
        const that = this;
        const resultsData = that.getRatingTrendResultsData();
        const resultsDataPointsMapped = _.map(resultsData, val => _.pick(val, ['x', 'y', 'count', 'descriptions', 'dataLabelColor']));
        const resultsDataPointBackgroundColor = _.map(resultsData, 'backgroundColor');
        const resultsDataBorderColor = _.map(resultsData, 'borderColor');
        const resultsDataBorderWidth = _.map(resultsData, 'borderWidth');
        // datasets order matters, z-index is least to greatest
        return {
            labels: that.getRatingTrendChartTimeAxisLabels(),
            datasets: [
                {
                    type: 'bubble',
                    fill: false,
                    backgroundColor: resultsDataPointBackgroundColor,
                    // pointStyle: resultsDataPointStyle,
                    aspectRatio: 1.0,
                    borderColor: resultsDataBorderColor,
                    borderWidth: resultsDataBorderWidth,
                    data: resultsDataPointsMapped,
                    datalabels: {
                        anchor: 'center',
                        align: 'center',
                        color: (context) => {
                            const value = context.dataset.data[context.dataIndex];
                            return value.dataLabelColor;
                        },
                        display: (context) => {
                            const value = context.dataset.data[context.dataIndex];
                            return value.count > 1;
                        },
                        font: context => ({
                            weight: 'bold',
                            family: that.state.utrRegularFontFamily,
                            size: (context.chart.width / 100),
                        }),
                        formatter: value => value.count,
                        offset: 2,
                        padding: 0,
                    },
                },
                {
                    data: that.getRatingTrendRatingsData(),
                    borderWidth: 2,
                    borderColor: that.state.utrLightTealColor,
                    fill: false,
                    pointRadius: 0,
                    pointHitRadius: 15,
                    datalabels: {
                        display: false,
                    },
                },
            ],
        };
    }

    getRatingTrendResultsData() {
        const { data: stats } = this.props.profileTabData?.stats || {};
        const resultsData = [];
        const months = stats?.ratingTrendChart && stats?.ratingTrendChart.months;
        for (let i = 0; i < months.length; i += 1) {
            const currentMonthTrendDetails = months[i];

            if (currentMonthTrendDetails.results) {
                for (let j = 0; j < currentMonthTrendDetails.results.length; j += 1) {
                    resultsData.push({
                        x: currentMonthTrendDetails.results[j].index,
                        y: currentMonthTrendDetails.results[j].rating,
                        count: currentMonthTrendDetails.results[j].aggregate.count,
                        descriptions: currentMonthTrendDetails.results[j].descriptions,
                        backgroundColor: this.getResultBackgroundColor(currentMonthTrendDetails.results[j].aggregate),
                        // pointStyle: this.getResultPointStyle(currentMonthTrendDetails.results[j].aggregate),
                        borderColor: this.getResultBorderColor(currentMonthTrendDetails.results[j].aggregate, currentMonthTrendDetails.results[j].playerPostedScore),
                        borderWidth: this.getResultBorderWidth(currentMonthTrendDetails.results[j].aggregate, currentMonthTrendDetails.results[j].playerPostedScore),
                        dataLabelColor: this.getResultDataLabelColor(currentMonthTrendDetails.results[j].aggregate),
                    });
                }
            }
        }
        return resultsData;
    }

    getRatingTrendChartTimeAxisLabels() {
        const { data: stats } = this.props.profileTabData?.stats || {};
        const labels = [];
        const { chartTicksPerMonth } = stats?.ratingTrendChart || {};
        for (let i = 0; i < stats?.ratingTrendChart.maxNonRatingScaleChartTicks; i += 1) {
            // only add every other label tick on x axis at beginning
            // when i reaches the first data point index, add all labels
            // this offsets 1/2 chartTicksPerMonth from y-axis
            // index of data starts at (1 x chartTicksPerMonth)
            if (i < chartTicksPerMonth) {
                if (i % 2 === 0) {
                    labels.push(i);
                }
            } else {
                labels.push(i);
            }
        }
        return labels;
    }

    getRatingTrendRatingsData() {
        const { data: stats } = this.props.profileTabData?.stats || {};
        const ratingTrendData = [];
        const months = stats?.ratingTrendChart?.months;
        for (let i = 0; i < months.length; i += 1) {
            const currentMonthTrendDetails = months[i];

            if (currentMonthTrendDetails.ratings && this.props.statsState.type === 'singles') {
                for (let j = 0; j < currentMonthTrendDetails.ratings.length; j += 1) {
                    ratingTrendData.push({
                        x: currentMonthTrendDetails.ratings[j].index,
                        y: currentMonthTrendDetails.ratings[j].rating,
                        singlesRating: currentMonthTrendDetails.ratings[j].rating && currentMonthTrendDetails.ratings[j].ratingDisplay,
                        month: currentMonthTrendDetails.month.name,
                    });
                }
            } else if (this.props.statsState.type === 'doubles') {
                for (let j = 0; j < 30; j += 1) {
                    ratingTrendData.push({
                        x: null,
                        y: stats?.currentRating,
                        doublesRating: stats?.currentRatingDisplay,
                    });
                }
            }
        }
        return ratingTrendData;
    }

    getResultBackgroundColor(resultAggregate) {
        if (resultAggregate.winsCount > 0 && resultAggregate.lossesCount > 0) {
            return '#f6f7f8';
        } if (resultAggregate.winsCount > 0) {
            return this.state.utrLightMagentaColor;
        } if (resultAggregate.lossesCount > 0) {
            return this.state.utrMediumGrayColor;
        }
        return '#f6f7f8';
    }

    getResultBorderColor(resultAggregate, playerPosted, arrayLength, index) {
        if ((arrayLength - index) <= 4) {
            return this.state.utrDarkBlueColor;
        }
        if (playerPosted) {
            return '#6aff00';
        } if (resultAggregate.winsCount > 0 && resultAggregate.lossesCount > 0) {
            return this.state.utrMediumGrayColor;
        } if (resultAggregate.winsCount > 0) {
            return this.state.utrMediumGrayColor;
        } if (resultAggregate.lossesCount > 0) {
            return this.state.utrLightMagentaColor;
        }
        return this.state.utrMediumGrayColor;
    }

    getResultBorderWidth(resultAggregate, playerPosted, arrayLength, index) {
        if ((arrayLength - index) <= 4) {
            return 2.0;
        }
        if (playerPosted) {
            return 2.0;
        } if (resultAggregate.winsCount > 0 && resultAggregate.lossesCount > 0) {
            return 1.0;
        } if (resultAggregate.winsCount > 0) {
            return 0.1;
        } if (resultAggregate.lossesCount > 0) {
            return 0.1;
        }
        return 1.0;
    }

    getResultDataLabelColor(resultAggregate) {
        if (resultAggregate.winsCount > 0 && resultAggregate.lossesCount > 0) {
            return this.state.utrMediumGrayColor;
        } if (resultAggregate.winsCount > 0) {
            return '#ffffff';
        } if (resultAggregate.lossesCount > 0) {
            return '#ffffff';
        }
        return this.state.utrMediumGrayColor;
    }

    getRatingTrendChartOptions() {
        const { data: stats } = this.props.profileTabData?.stats || {};
        const that = this;
        return {
            animation: {
                duration: 0,
            },
            elements: {
                point: {
                    radius: (context) => {
                        const value = context.dataset.data[context.dataIndex];
                        const size = context.chart.width;
                        const base = value.count > 1 ? 0.2 : 0.1;
                        return (size / 24) * base;
                    },
                },
            },
            layout: {
                padding: {
                    left: 0,
                    right: 0,
                    top: 50,
                    bottom: 50,
                },
            },
            legend: {
                display: false,
            },
            maintainAspectRatio: false,
            responsive: true,
            tooltips: {
                enabled: true,
                callbacks: {
                    title: (items, data) => {
                        if (items[0].datasetIndex === 0) {
                            return 'Result(s)';
                        }
                        if (items[0].datasetIndex === 1) {
                            return ratingTypes.tennis;
                        }
                    },
                    label: (item, data) => {
                        if (item.datasetIndex === 0) {
                            return _.map(data.datasets[item.datasetIndex].data[item.index].descriptions, 'details');
                        }
                        if (item.datasetIndex === 1) {
                            if (this.props.statsState.type === 'singles') {
                                const weekDictionary = {
                                    0: '1st Week of',
                                    1: '2nd Week of',
                                    2: '3rd Week of',
                                    3: '4th Week of',
                                };
                                return `${weekDictionary[item.index % 4]} ${data.datasets[item.datasetIndex].data[item.index].month} - ${data.datasets[item.datasetIndex].data[item.index].singlesRating}`;
                            }
                            if (this.props.statsState.type === 'doubles') { return `${ratingTypes.tennis} - ${data.datasets[item.datasetIndex].data[item.index].doublesRating} `; }
                        }
                    },

                },
                backgroundColor: '#fff',
                displayColors: false,
                titleFontColor: that.state.utrMediumGrayColor,
                titleFontFamily: that.state.utrRegularFontFamily,
                titleMarginBottom: 10,
                bodyFontColor: that.state.utrMediumGrayColor,
                bodyFontFamily: that.state.utrRegularFontFamily,
                bodyFontSize: this.props.statsState.type === 'singles' ? 12 : 10,
                bodySpacing: 10,
                xAlign: 'center',
                yAlign: 'bottom',
                xPadding: 16,
                yPadding: 16,
            },
            hover: {
                mode: null,
            },
            scales: {
                showScaleValues: true,
                yAxes: [{
                    display: true,
                    gridLines: {
                        // display: false,
                        drawBorder: false,
                        // borderDash: [2, 4],
                        drawOnChartArea: true,
                        drawTicks: false,
                        // zeroLineBorderDash: [2, 4]
                    },
                    scaleLabel: {
                        display: true,
                        labelString: ratingTypes.tennis,
                        fontSize: 12,
                        fontStyle: '400',
                        fontFamily: that.state.utrRegularFontFamily,
                    },
                    // offset: true,
                    ticks: {
                        suggestedMax: stats?.ratingTrendChart.maxRatingForScale,
                        stepSize: stats?.ratingTrendChart.ratingScaleStepSize,
                        suggestedMin: stats?.ratingTrendChart.minRatingForScale,
                        padding: 10,
                        fontSize: 12,
                        fontStyle: '400',
                        fontFamily: that.state.utrRegularFontFamily,
                        callback: (value, index, values) => {
                            const displayOnAxis = ['00', '25', '50', '75'];
                            const valueRounded = value.toFixed(2);
                            if (displayOnAxis.indexOf(valueRounded.split('.')[1]) > -1) {
                                return valueRounded;
                            }
                        },
                    },
                }],
                xAxes: [{
                    display: true,
                    gridLines: {
                        display: false,
                        drawBorder: false,
                        // zeroLineBorderDash: [2, 4]
                    },
                    // offset: true,
                    scaleLabel: {
                        display: false,
                    },
                    ticks: {
                        min: 0,
                        max: stats?.ratingTrendChart.maxNonRatingScaleChartTicks,
                        minRotation: 0,
                        maxRotation: 0,
                        fontSize: 12,
                        fontStyle: '400',
                        fontFamily: that.state.utrRegularFontFamily,
                        // stepSize: 1, stepsize is one since we have labels array with all possible values
                        autoSkip: false,
                        callback: (value, index, values) => {
                            const months = _.map(stats?.ratingTrendChart?.months, 'month');
                            const monthAbbrs = _.map(months, 'abbr');
                            const { chartTicksPerMonth } = stats?.ratingTrendChart || {};
                            // don't return anything for no tick displays
                            if (value > 0 && value % chartTicksPerMonth === 0) {
                                return monthAbbrs[(value / chartTicksPerMonth) - 1];
                            }
                        },
                    },
                }],
            },
        };
    }
    // End Rating Trend CHart Functions

    // Start VictoryMargin Chart Functions
    setVictoryMarginChartRef(node) {
        this.victoryMarginChartRef = node;
    }

    getVictoryMarginChartData(canvas) {
        const that = this;
        const resultsData = that.getVictoryMarginResultsData();
        const resultsDataPointsMapped = _.map(resultsData, val => _.pick(val, ['x', 'y', 'count', 'descriptions', 'dataLabelColor']));
        const resultsDataPointBackgroundColor = _.map(resultsData, 'backgroundColor');
        // const resultsDataPointStyle = _.map(resultsData, 'pointStyle');
        const resultsDataBorderColor = _.map(resultsData, 'borderColor');
        const resultsDataBorderWidth = _.map(resultsData, 'borderWidth');
        return {
            labels: that.getVictoryMarginChartRatingsAxisLabels(),
            datasets: [
                {
                    fill: false,
                    backgroundColor: resultsDataPointBackgroundColor,
                    // pointStyle: resultsDataPointStyle,
                    aspectRatio: 1.0,
                    borderColor: resultsDataBorderColor,
                    borderWidth: resultsDataBorderWidth,
                    data: resultsDataPointsMapped,
                    datalabels: {
                        anchor: 'center',
                        align: 'center',
                        color: (context) => {
                            const value = context.dataset.data[context.dataIndex];
                            return value.dataLabelColor;
                        },
                        display: (context) => {
                            const value = context.dataset.data[context.dataIndex];
                            return value.count > 1;
                        },
                        font: context => ({
                            weight: 'bold',
                            family: that.state.utrRegularFontFamily,
                            size: (context.chart.width / 100),
                        }),
                        formatter: value => value.count,
                        offset: 2,
                        padding: 0,
                    },
                },
            ],
        };
    }

    getVictoryMarginChartOptions() {
        const { data: stats } = this.props.profileTabData?.stats || {};
        const that = this;
        return {
            elements: {
                point: {
                    radius: (context) => {
                        const value = context.dataset.data[context.dataIndex];
                        const size = context.chart.width;
                        const base = value.count > 1 ? 0.2 : 0.1;
                        return (size / 24) * base;
                    },
                },
            },
            layout: {
                padding: {
                    left: 0,
                    right: 0,
                    top: 50,
                    bottom: 50,
                },
            },
            legend: {
                display: false,
            },
            maintainAspectRatio: false,
            responsive: true,
            tooltips: {
                enabled: true,
                callbacks: {
                    title: (items, data) => 'Result(s)',
                    label: (item, data) => _.map(data.datasets[item.datasetIndex].data[item.index].descriptions, 'details'), // ,
                    // afterLabel: (items, data) => {
                    //    return 'afterlabel';
                    // }
                },
                backgroundColor: '#fff',
                displayColors: false,
                titleFontColor: that.state.utrMediumGrayColor,
                titleFontFamily: that.state.utrRegularFontFamily,
                titleMarginBottom: 10,
                bodyFontColor: that.state.utrMediumGrayColor,
                bodyFontFamily: that.state.utrRegularFontFamily,
                bodySpacing: 10,
                xAlign: 'center',
                yAlign: 'bottom',
                xPadding: 16,
                yPadding: 16,
            },
            hover: {
                mode: null,
            },
            annotation: {
                events: ['mouseenter', 'mouseleave'],
                annotations: [{
                    type: 'line',
                    mode: 'vertical',
                    scaleID: 'x-axis-0',
                    value: stats?.victoryMarginChart.currentRating,
                    borderColor: that.state.utrLightTealColor,
                    borderWidth: 2,
                    drawTime: 'beforeDatasetsDraw',
                    label: {
                        backgroundColor: '#fff',
                        fontFamily: that.state.utrRegularFontFamily,
                        fontColor: that.state.utrMediumGrayColor,
                        xPadding: 16,
                        yPadding: 16,
                        position: 'top',
                        xAdjust: -100,
                        enabled: false,
                        content: `${ratingTypes.tennis} - ${stats.victoryMarginChart.currentRatingDisplay}`,
                    },
                    onMouseenter() {
                        if (this.chartInstance.options.annotation.annotations[0].label.enabled === false) {
                            this.chartInstance.options.annotation.annotations[0].label.enabled = true;
                            this.chartInstance.update();
                        }
                    },
                    onMouseleave() {
                        if (this.chartInstance.options.annotation.annotations[0].label.enabled === true) {
                            this.chartInstance.options.annotation.annotations[0].label.enabled = false;
                            this.chartInstance.update();
                        }
                    },
                }, {
                    type: 'line',
                    mode: 'horizontal',
                    scaleID: 'y-axis-0',
                    value: '50',
                    borderColor: that.state.utrMediumGrayColor,
                    borderWidth: 1,
                    drawTime: 'beforeDatasetsDraw',
                }],
            },
            scales: {
                showScaleValues: true,
                yAxes: [{
                    id: 'y-axis-0',
                    display: true,
                    gridLines: {
                        display: false,
                        drawBorder: false,
                        // zeroLineBorderDash: [2, 4]
                    },
                    scaleLabel: {
                        display: true,
                        labelString: '% Games Won',
                        fontSize: 12,
                        fontStyle: '400',
                        fontFamily: that.state.utrRegularFontFamily,
                    },
                    // offset: true,
                    ticks: {
                        min: 0,
                        max: stats?.victoryMarginChart.maxNonRatingScaleChartTicks,
                        minRotation: 0,
                        maxRotation: 0,
                        fontSize: 12,
                        fontStyle: '400',
                        fontFamily: that.state.utrRegularFontFamily,
                        stepSize: stats?.victoryMarginChart.nonRatingScaleStepSize, // stepsize is one since we have labels array with all possible values
                        autoSkip: false,
                        callback: (value, index, values) => {
                            if (value % 20 === 0) {
                                return `${value.toString()}%`;
                            }
                        },
                    },
                }],
                xAxes: [{
                    id: 'x-axis-0',
                    // type: 'linear',
                    display: true,
                    gridLines: {
                        // display: false,
                        drawBorder: false,
                        // borderDash: [2, 4],
                        drawOnChartArea: true,
                        drawTicks: false,
                        // zeroLineBorderDash: [2, 4]
                    },
                    // offset: true,
                    scaleLabel: {
                        display: true,
                        labelString: ratingTypes.tennis,
                        fontSize: 12,
                        fontStyle: '400',
                        fontFamily: that.state.utrRegularFontFamily,
                    },
                    ticks: {
                        max: stats?.victoryMarginChart.maxRatingForScale,
                        stepSize: stats?.victoryMarginChart.ratingScaleStepSize,
                        min: stats?.victoryMarginChart.minRatingForScale,
                        padding: 10,
                        fontSize: 12,
                        fontStyle: '400',
                        fontFamily: that.state.utrNumeralsFontFamily,
                        callback: (value, index, values) => {
                            const displayOnAxis = ['00', '25', '50', '75'];
                            const valueRounded = value.toFixed(2);
                            if (displayOnAxis.indexOf(valueRounded.split('.')[1]) > -1) {
                                return valueRounded;
                            }
                        },
                    },
                }],
            },
        };
    }

    getVictoryMarginResultsData() {
        const { data: stats } = this.props.profileTabData?.stats || {};
        const resultsData = [];
        const { results } = stats?.victoryMarginChart || {};
        for (let i = 0; i < results.length; i += 1) {
            resultsData.push({
                x: results[i].rating,
                y: results[i].index,
                count: results[i].aggregate.count,
                descriptions: results[i].descriptions,
                backgroundColor: this.getResultBackgroundColor(results[i].aggregate),
                // pointStyle: this.getResultPointStyle(results[i].aggregate),
                borderColor: this.getResultBorderColor(results[i].aggregate, results[i].playerPostedScore, results.length, i + 1),
                borderWidth: this.getResultBorderWidth(results[i].aggregate, results[i].playerPostedScore, results.length, i + 1),
                dataLabelColor: this.getResultDataLabelColor(results[i].aggregate),
            });
        }
        return resultsData;
    }

    getVictoryMarginChartRatingsAxisLabels() {
        const { data: stats } = this.props.profileTabData?.stats || {};
        const labels = [];
        for (let i = stats?.victoryMarginChart?.minRatingForScale; i <= stats?.victoryMarginChart?.maxRatingForScale; i += (stats?.victoryMarginChart?.ratingScaleStepSize || 1)) {
            labels.push(i);
        }
        return labels;
    }

    handleStatsChange(selection) {
        const params = {
            type: selection.value,
            fetchAllResults: true,
        };
        this.props.updateStatsParams(params);
    }
    // End VictoryMargin Chart Functions

    handleStatsViewChange(view) {
        const { auth, playerId, isOwnProfile } = this.props;
        this.hasResolvedInitialStatsView = true;
        this.setState({ activeStatsView: view });
        trackEvent(profileAnalyticsEvents.STATS_VIEW_CHANGED, {
            view, viewReason: 'click', ...getAnalyticsCommonTraits(auth),
        });
        trackEvent(statsAnalyticsEvents.SUBTAB_CLICKED, {
            ...getActivityStatsTraits(auth, playerId, isOwnProfile),
            subtab_name: statsSubtabNamesByView[view],
        });
    }

    handleShowMore(show) {
        const { items } = this.state;
        const history = (this.props.profileData.extendedRatingProfile && this.props.profileData.extendedRatingProfile.history) ? this.props.profileData.extendedRatingProfile.history : [];

        if (history) {
            if (show) {
                this.setState({ items: [...items, ...history.slice(5, history.length)], hasMore: false });
            } else {
                this.setState({ items: history.slice(0, 5), hasMore: true });
            }
        }
    }

    render() {
        const {
            auth,
            statsState,
            playerId,
            profileData,
            rankings,
            onShowUpgradeToPowerPopup,
            ptsRankings,
            isUserLoggedIn,
            isActivityMetricsEnabled,
            showActivityNewBadge,
            isPerformanceStatsEnabled,
            showPerformanceNewBadge,
            onViewAllResults,
            isOwnProfile,
        } = this.props;
        const { activeStatsView } = this.state;
        let effectiveStatsView = activeStatsView;
        if ((activeStatsView === statsViewTypes.ACTIVITY && !isActivityMetricsEnabled) ||
            (activeStatsView === statsViewTypes.PERFORMANCE && !isPerformanceStatsEnabled)) {
            effectiveStatsView = statsViewTypes.RATING;
        }
        const { data: stats, isLoading } = this.props.profileTabData?.stats || {};
        const isRatingStatsEmpty = !isLoading && stats?.title === null;
        const volData = this.props.volumetricStats?.data;
        const hasActivityData = !!volData && (!!volData?.sports?.tennis || !!volData?.sports?.pickleball);
        const hasNoStatsData = isRatingStatsEmpty && isActivityMetricsEnabled && !hasActivityData;
        const showGatedRatingEmptyState = isActivityMetricsEnabled && isRatingStatsEmpty;
        const teamTypeOptions = [
            {
                label: 'Singles',
                value: 'singles',
            },
        ];

        const durationOptions = [
            {
                label: 'Last 6 months',
                value: 6,
            },
            {
                label: 'Last 12 months',
                value: 12,
            },
        ];

        const fetchAllResultsOptions = [
            {
                label: 'Results that count for rating',
                value: false,
            },
            {
                label: 'All results',
                value: true,
            },
        ];
        const defaultTeamType = _.find(teamTypeOptions, { value: statsState.type });
        const defaultDuration = _.find(durationOptions, { value: statsState.months });
        const defaultFetchAllResults = _.find(fetchAllResultsOptions, { value: statsState.fetchAllResults });
        const rating = stats?.ratingCircle || {
            doublesUtr: stats?.currentRating,
            myUtrSingles: stats?.currentRating,
            myUtrDoubles: stats?.currentRating,
            singlesUtr: stats?.currentRating,
            myUtrProgressSingles: 0,
            myUtrProgressDoubles: 0,
            ratingProgressDoubles: 0,
            ratingProgressSingles: 0,
        };
        const userIsPowered = auth && auth.user && auth.user.isPowered;
        const utrType = statsState.resultType === 'verified' ? 'sanctioned' : 'unsanctioned';
        const updatedRating = getRatingDetails(setRatingChoice({ player: rating, ratingType: statsState.type, utrType }), userIsPowered, profileData.isPro || userIsPowered);
        const getInteger = number => parseInt(number);
        const getDecimalsString = (number) => {
            const temp = Math.round((number - parseInt(number)) * 100);
            return temp < 10 ? `0${parseInt(temp).toString()}` : parseInt(temp).toString();
        };
        const notableMatchEventName = stats?.notableMatchEventName;
        let round = stats?.notableMatch?.round;
        // console.log('NOTABLE MATCH: ', stats.notableMatch);
        if (round || notableMatchEventName) {
            round = {
                ...(round),
                name: <DescriptionStylable
                    desc={[
                        ...(notableMatchEventName ? [notableMatchEventName] : []),
                        ...(round && round.name ? [round.name] : []),
                        ...([formatMatchDate(stats?.notableMatch?.date)]),
                    ]}
                />,
            };
        }
        const history = (profileData.extendedRatingProfile && profileData.extendedRatingProfile.history) ? profileData.extendedRatingProfile.history : [];

        return (
            <React.Fragment>
                {(isActivityMetricsEnabled || isPerformanceStatsEnabled) && (
                    <div className={styles.statsViewToggle}>
                        <div className="container">
                            <div className={styles.statsViewToggleInner}>
                                <div className={styles.statsViewBtnCol}>
                                    <button
                                        type="button"
                                        className={`${styles.statsViewBtn} ${effectiveStatsView === statsViewTypes.RATING ? styles.statsViewBtnActive : ''}`}
                                        onClick={() => this.handleStatsViewChange(statsViewTypes.RATING)}
                                        data-testid="profile.stats.rating-view-btn"
                                    >
                                        <span className="d-none d-md-inline" data-testid="profile.stats.rating-view-btn.label-full">Rating Stats</span>
                                        <span className="d-inline d-md-none" data-testid="profile.stats.rating-view-btn.label-short">Rating</span>
                                    </button>
                                </div>
                                {isActivityMetricsEnabled && (
                                    <div className={styles.statsViewBtnCol}>
                                        {showActivityNewBadge && <span className={`${styles.statsViewNewBadge} d-md-none`} data-testid="profile.stats.activity-view-btn.new-badge-mobile">NEW</span>}
                                        <button
                                            type="button"
                                            className={`${styles.statsViewBtn} ${effectiveStatsView === statsViewTypes.ACTIVITY ? styles.statsViewBtnActive : ''}`}
                                            onClick={() => this.handleStatsViewChange(statsViewTypes.ACTIVITY)}
                                            data-testid="profile.stats.activity-view-btn"
                                        >
                                            <span className="d-none d-md-inline" data-testid="profile.stats.activity-view-btn.label-full">Activity Stats</span>
                                            <span className="d-inline d-md-none" data-testid="profile.stats.activity-view-btn.label-short">Activity</span>
                                            {showActivityNewBadge && <span className={`${styles.statsViewNewBadge} d-none d-md-inline`} data-testid="profile.stats.activity-view-btn.new-badge">NEW</span>}
                                        </button>
                                    </div>
                                )}
                                {isPerformanceStatsEnabled && (
                                    <div className={styles.statsViewBtnCol}>
                                        {showPerformanceNewBadge && <span className={`${styles.statsViewNewBadge} d-md-none`} data-testid="profile.stats.performance-view-btn.new-badge-mobile">NEW</span>}
                                        <button
                                            type="button"
                                            className={`${styles.statsViewBtn} ${effectiveStatsView === statsViewTypes.PERFORMANCE ? styles.statsViewBtnActive : ''}`}
                                            onClick={() => this.handleStatsViewChange(statsViewTypes.PERFORMANCE)}
                                            data-testid="profile.stats.performance-view-btn"
                                        >
                                            <span className="d-none d-md-inline" data-testid="profile.stats.performance-view-btn.label-full">Performance Stats</span>
                                            <span className="d-inline d-md-none" data-testid="profile.stats.performance-view-btn.label-short">Performance</span>
                                            {showPerformanceNewBadge && <span className={`${styles.statsViewNewBadge} d-none d-md-inline`} data-testid="profile.stats.performance-view-btn.new-badge">NEW</span>}
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
                {(!(isActivityMetricsEnabled || isPerformanceStatsEnabled) || effectiveStatsView === statsViewTypes.RATING) && (
                    <TabContentBase
                        displayOnlyMainContent={true}
                        isUserLoggedIn={isUserLoggedIn}
                        className={`${styles.stats}`}
                    >
                        <span className={styles.sportLabel} data-testid="profile.stats.sport-label">TENNIS</span>
                        <div className={styles.segmentedControl}>
                            <button
                                type="button"
                                className={`${styles.segmentedBtn} ${styles.segmentedBtnLeft} ${statsState.type === gameTypes.SINGLES ? styles.segmentedBtnActive : ''}`}
                                onClick={() => this.handleStatsChange({ value: gameTypes.SINGLES })}
                                data-testid="profile.stats.singles-btn"
                            >
                                Singles
                            </button>
                            <button
                                type="button"
                                className={`${styles.segmentedBtn} ${styles.segmentedBtnRight} ${statsState.type === gameTypes.DOUBLES ? styles.segmentedBtnActive : ''}`}
                                onClick={() => this.handleStatsChange({ value: gameTypes.DOUBLES })}
                                data-testid="profile.stats.doubles-btn"
                            >
                                Doubles
                            </button>
                        </div>
                        {showGatedRatingEmptyState && (
                            <div className={styles.emptyStateContainer} data-testid="profile.stats.empty-state">
                                <p className={styles.emptyStateTextBlack} data-testid="profile.stats.empty-state.text">
                                    {isOwnProfile
                                        ? 'Rating stats are not available because you do not have enough match results.'
                                        : 'Rating stats are not available because the player does not have enough match results.'}
                                </p>
                                {isOwnProfile && (
                                    <div className={styles.emptyStateLinks}>
                                        <Link
                                            to={paths.searchEvents}
                                            className={styles.emptyStateLink}
                                            onClick={() => trackEvent(profileAnalyticsEvents.EVENT_CTA_CLICKED, {
                                                ctaLabel: 'Find Events',
                                                ctaUrl: paths.searchEvents,
                                                section: 'rating_stats_empty',
                                                ...getAnalyticsCommonTraits(auth),
                                            })}
                                            data-testid="profile.stats.empty-state.find-events-link"
                                        >
                                            Find Events
                                        </Link>
                                        <span className={styles.emptyStateDivider} />
                                        <Link
                                            to={paths.searchPlayers}
                                            className={styles.emptyStateLink}
                                            onClick={() => trackEvent(profileAnalyticsEvents.EVENT_CTA_CLICKED, {
                                                ctaLabel: 'Find Players',
                                                ctaUrl: paths.searchPlayers,
                                                section: 'rating_stats_empty',
                                                ...getAnalyticsCommonTraits(auth),
                                            })}
                                            data-testid="profile.stats.empty-state.find-players-link"
                                        >
                                            Find Players
                                        </Link>
                                        <span className={styles.emptyStateDivider} />
                                        <Link
                                            to={paths.postScoreSelect}
                                            className={styles.emptyStateLink}
                                            onClick={() => trackEvent(profileAnalyticsEvents.EVENT_CTA_CLICKED, {
                                                ctaLabel: 'Post Scores',
                                                ctaUrl: paths.postScoreSelect,
                                                section: 'rating_stats_empty',
                                                ...getAnalyticsCommonTraits(auth),
                                            })}
                                            data-testid="profile.stats.empty-state.post-scores-link"
                                        >
                                            Post Scores
                                        </Link>
                                    </div>
                                )}
                            </div>
                        )}
                        {!hasNoStatsData && isLoading && (
                            <React.Fragment>
                                <div className="title" />
                                <span data-testid="profile.stats.loading-msg">Loading Player Stats</span>
                            </React.Fragment>
                        )}
                        {!hasNoStatsData && !isLoading && !stats && (
                            <React.Fragment>
                                <div className="title" />
                                <div className={`${styles.unsuccessfulStatsRetrieval}`} data-testid="profile.stats.no-data-msg">
                                    Unable to retrieve stats for player
                                </div>
                            </React.Fragment>
                        )}
                        {!hasNoStatsData && !isLoading && stats && stats.title !== null && (
                            <React.Fragment>
                                <div className="title mb0" />
                                {updatedRating?.status?.toLowerCase() !== 'rated' && rankings.rankings && rankings.rankings.length > 0 && (
                                    <div className={`${styles.unreliableRatingBanner}`} data-testid="profile.stats.unreliable-rankings-banner">
                                        Player rankings are not reliable because player does not have enough match results.
                                    </div>
                                )}
                                <RankingsV2
                                    rankingCards={buildRankingCards(ptsRankings, rankings, statsState.type)}
                                />
                                {updatedRating?.status?.toLowerCase() !== 'rated' && (
                                    <div className={`${styles.unreliableRatingBanner}`} data-testid="profile.stats.unreliable-metrics-banner">
                                        Player metrics are not reliable because player does not have enough match results.
                                    </div>
                                )}
                                <div className={`d-flex flex-row align-items-center flex-wrap`}>
                                    <div className={`mr-auto mb24`}>
                                        <div className={`title mt24 mb0 text-uppercase`} data-testid="profile.stats.verified-stats-title">
                                            Verified {this.props.statsState.type} stats - last {this.props.statsState.months} months
                                        </div>
                                        <div className={`${styles.subTitle} mt8`} data-testid="profile.stats.verified-stats-subtitle">
                                            {stats?.subtitle}
                                        </div>
                                    </div>
                                    <div className={`d-none d-md-flex flex-row flex-wrap`}>
                                        <FilterButtons
                                            showTeamTypeOptions={false}
                                            teamTypeOptions={teamTypeOptions}
                                            defaultTeamType={defaultTeamType}
                                            durationOptions={durationOptions}
                                            defaultDuration={defaultDuration}
                                            fetchAllResultsOptions={fetchAllResultsOptions}
                                            defaultFetchAllResults={defaultFetchAllResults}
                                            popOverMenuClassName={`d-inline-block`}
                                            onSelectedTeamType={(val) => {
                                                statsState.type = val;
                                                this.props.updateStatsParams(statsState);
                                            }}
                                            onSelectedDuration={(val) => {
                                                statsState.months = val;
                                                this.props.updateStatsParams(statsState);
                                            }}
                                            onSelectedFetchAllResults={(val) => {
                                                statsState.fetchAllResults = val;
                                                this.props.updateStatsParams(statsState);
                                            }}
                                        />
                                    </div>
                                    <div className={`d-block d-md-none w-100`}>
                                        <FilterButtons
                                            teamTypeOptions={teamTypeOptions}
                                            defaultTeamType={defaultTeamType}
                                            durationOptions={durationOptions}
                                            defaultDuration={defaultDuration}
                                            fetchAllResultsOptions={fetchAllResultsOptions}
                                            defaultFetchAllResults={defaultFetchAllResults}
                                            popOverMenuClassName={`d-block`}
                                            buttonCssClassName={`w-100`}
                                            onSelectedTeamType={(val) => {
                                                statsState.type = val;
                                                this.props.updateStatsParams(statsState);
                                            }}
                                            onSelectedDuration={(val) => {
                                                statsState.months = val;
                                                this.props.updateStatsParams(statsState);
                                            }}
                                            onSelectedFetchAllResults={(val) => {
                                                statsState.fetchAllResults = val;
                                                this.props.updateStatsParams(statsState);
                                            }}
                                        />
                                    </div>
                                </div>
                                <hr className={`bb mb24 mt0`} />
                                {
                                    <React.Fragment>
                                        <div className={`d-flex flex-row align-items-stretch flex-wrap ${styles.basic}`}>
                                            {!userIsPowered && !profileData.isPro && (
                                                <div className={`${styles.upgradeButton}`}>
                                                    <TrackedClick
                                                        eventName="Access Player Metrics Clicked"
                                                        label="Access Player Metrics"
                                                        traits={
                                                            {
                                                                pageLocation: clickCategories.POWER_UPGRADE,
                                                                uxType: 'button',
                                                                content: 'ACCESS PLAYER METRICS',
                                                                subscriptionType: 'power',
                                                            }
                                                        }
                                                    >
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-lg"
                                                            onClick={onShowUpgradeToPowerPopup}
                                                            data-testid="profile.stats.upgrade-metrics-btn"
                                                            {...getClickAttrs({
                                                                category: clickCategories.POWER_UPGRADE,
                                                                context: `Access Player Metrics Clicked`,
                                                                location: 'Player Profile Stats Tab',
                                                            })}
                                                        >
                                                            ACCESS PLAYER METRICS
                                                        </button>
                                                    </TrackedClick>
                                                </div>
                                            )}
                                            <div className={`flex-1 ${styles.section} ${!userIsPowered && !profileData.isPro ? styles.blur : ''}`}>
                                                <div className={`${styles.title} text-highlight2 text-uppercase text-center show-ellipsis`} data-testid="profile.stats.metrics-title">
                                                    {stats?.title}
                                                </div>
                                                <div className={`d-flex flex-column flex-sm-row align-items-center`}>
                                                    <div className={`${styles.numberStats}`}>
                                                        <RatingCircle
                                                            rating={updatedRating}
                                                            isProProfile={profileData.isPro}
                                                            auth={auth}
                                                            ratingCircleClassName={styles.ratingCircles}
                                                            ratingCirclesContainerClassName={styles.ratingCirclesContainer}
                                                        />
                                                    </div>
                                                    <NumberStats
                                                        statValue={`${stats?.winsCount} - ${stats?.lossesCount}`}
                                                        statLabel={'Win/Loss'}
                                                        gradientInfo={(
                                                            <div className={`w-100 ${styles.statGradientWinsLosses}`}>
                                                                <div style={{
                                                                    height: '3px',
                                                                    borderRadius: '3px',
                                                                    width: `${Math.round((stats?.winsCount / (stats?.winsCount + stats?.lossesCount)) * 100) - 2}%`,
                                                                    marginRight: '2px',
                                                                    background: `${this.state.utrLightMagentaColor}`,
                                                                    display: 'inline-block',
                                                                }}
                                                                />
                                                                <div style={{
                                                                    height: '3px',
                                                                    borderRadius: '3px',
                                                                    width: `${100 - Math.round((stats?.winsCount / (stats?.winsCount + stats?.lossesCount)) * 100) - 1}%`,
                                                                    background: `${this.state.utrMediumGrayColor}`,
                                                                    display: 'inline-block',
                                                                }}
                                                                />
                                                            </div>
                                                        )}

                                                    />
                                                    <NumberStats
                                                        statValue={stats?.winStreak}
                                                        statLabel={'Longest Win Streak'}
                                                        gradientInfo={<div className={`w-100 ${styles.statGradientUtrRange}`} />}
                                                        infoButton={<InfoButton hoverText={`The longest number of consecutive matches won in the filtered time frame. Note, walkovers/withdrawals resets the streak.`} />}
                                                    />
                                                    {this.props.statsState.type === gameTypes.SINGLES && (
                                                        <NumberStats
                                                            ratingTrend={(
                                                                <RatingTrend
                                                                    {...stats?.ratingTrend}
                                                                />
                                                            )}
                                                            statLabel={`3 Mo. Trend`}
                                                            gradientInfo={<div className={`w-100 ${styles.statGradientUtrRange}`} />}
                                                            infoButton={<InfoButton hoverText={`Three-Month Trending UTR is a subset of UTR in which a player's rating is calculated using only matches from the last three months.`} />}

                                                        />
                                                    )}
                                                </div>
                                            </div>
                                            {stats?.notableMatch && (
                                                <div className={`${styles.notableMatchSection} ${styles.notableMatch} ${!userIsPowered && !profileData.isPro ? styles.blur : ''}`}>
                                                    <div className={`${styles.title} text-highlight2 text-uppercase text-center`} data-testid="profile.stats.best-win-title">
                                                        {statsState.months === 6 ? 'Best Win - Last 6 Months' : 'Best Win - Last 12 Months'}
                                                        <InfoButton hoverText={<React.Fragment>Highest rated opponent that {stats?.playerFirstInitialLastName} has defeated.</React.Fragment>} />
                                                    </div>
                                                    <ScoreCard
                                                        {...stats?.notableMatch}
                                                        playerId={playerId}
                                                        showDecimalForOwn={true}
                                                        gameType={statsState.type}
                                                        forceCardView={true}
                                                        timeZoneValue={'UTC'}
                                                        showVerified={false}
                                                        isProProfile={profileData.isPro}
                                                        round={round}
                                                        data-testid={stats?.notableMatch?.id ? `profile.stats.best-win-${stats.notableMatch.id}` : 'profile.stats.best-win'}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                        <div className={`${styles.section}`}>
                                            <div className={`d-flex flex-row align-items-center`}>
                                                <div className={`title text-uppercase mt24 mb0 flex-1`} data-testid="profile.stats.historical-title">
                                                    Historical - Last {this.props.statsState.months} Months
                                                </div>
                                                <div
                                                    className={`${styles.chartLink} ${this.state.chartToDisplay === 'ratingTrend' ? styles.selected : ''}`}
                                                    onClick={(ev) => {
                                                        this.setState({
                                                            chartToDisplay: 'ratingTrend',
                                                        });
                                                    }}
                                                    data-testid="profile.stats.rating-history-tab"
                                                >
                                                    {this.props.statsState.type === gameTypes.SINGLES ? `Rating History` : `Performance`}
                                                </div>
                                                <div
                                                    className={`${styles.chartLink} mr0 ${this.state.chartToDisplay === 'victoryMargin' ? styles.selected : ''}`}
                                                    onClick={(ev) => {
                                                        this.setState({
                                                            chartToDisplay: 'victoryMargin',
                                                        });
                                                    }}
                                                    data-testid="profile.stats.results-analysis-tab"
                                                >
                                                    Results Analysis
                                                </div>
                                            </div>
                                            <div className={`d-block`}>
                                                <HowTheChartsWorkInfoPopup
                                                    linkTextClassName={styles.howTheChartsWorkLink}
                                                    monthsCount={stats?.monthsCount}
                                                    linkText="How the charts work"
                                                    cancelText="Got it"
                                                    statsState={this.props.statsState}
                                                />
                                            </div>
                                            <div className={`${styles.legend}`}>

                                                <div className={`${styles.win}`} data-testid="profile.stats.legend.win">
                                                    <span className={`${styles.indicator}`} />
                                                    Win
                                                </div>
                                                <div className={`${styles.loss}`} data-testid="profile.stats.legend.loss">
                                                    <span className={`${styles.indicator}`} />
                                                    Loss
                                                </div>
                                                <div className={`${styles.selfposted}`} data-testid="profile.stats.legend.self-posted">
                                                    <span className={`${styles.indicator}`} />
                                                    Self-Posted
                                                </div>
                                                {this.state.chartToDisplay === 'victoryMargin' && (
                                                    <div className={`${styles.recentMatches}`} data-testid="profile.stats.legend.recent-matches">
                                                        <span className={`${styles.indicator}`} />
                                                        Most Recent Matches
                                                    </div>
                                                )}
                                                <div className={`${styles.undecided}`} data-testid="profile.stats.legend.other">
                                                    <span className={`${styles.indicator}`} />
                                                    Other
                                                </div>
                                                <div className={`${styles.utr}`} data-testid="profile.stats.legend.player">
                                                    <span className={`${styles.indicator}`} />
                                                    {stats?.playerFirstInitialLastName}
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`${styles.section} d-flex tab-bar pt0 pl0 pr0 pb0`}>
                                            {!userIsPowered && !profileData.isPro && (
                                                <div className={`${styles.upgradeButton}`}>
                                                    <TrackedClick
                                                        eventName="Access Player Metrics Clicked"
                                                        label="Access Player Metrics"
                                                        traits={
                                                            {
                                                                pageLocation: clickCategories.POWER_UPGRADE,
                                                                uxType: 'button',
                                                                content: 'ACCESS PLAYER METRICS',
                                                                subscriptionType: 'power',
                                                            }
                                                        }
                                                    >
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-lg"
                                                            onClick={onShowUpgradeToPowerPopup}
                                                            data-testid="profile.stats.upgrade-metrics-btn"
                                                            {...getClickAttrs({
                                                                category: clickCategories.POWER_UPGRADE,
                                                                context: `Access Player Metrics Clicked`,
                                                                location: 'Player Profile Stats Tab',
                                                            })}
                                                        >
                                                            ACCESS PLAYER METRICS
                                                        </button>
                                                    </TrackedClick>
                                                </div>
                                            )}
                                            <div className={`${styles.chartContainer} ${!userIsPowered && !profileData.isPro ? styles.blur : ''} ${this.state.chartToDisplay === 'ratingTrend' ? 'd-block w-100' : 'd-none'} auto-scroll`}>
                                                {stats?.ratingTrendChart && (
                                                    <div className={`${styles.chart}`}>
                                                        <Line
                                                            data={canvas => this.getRatingTrendChartData(canvas)}
                                                            options={this.getRatingTrendChartOptions()}
                                                            width={1200}
                                                            height={440}
                                                            ref={this.setRatingTrendChartRef}
                                                        />
                                                    </div>
                                                )}
                                                {!stats?.ratingTrendChart && (
                                                    <div className="text-center mt48" data-testid="profile.stats.rating-trend-empty-msg">
                                                        Not enough results to display the chart
                                                    </div>
                                                )}
                                            </div>
                                            <div className={`${styles.chartContainer} ${!userIsPowered && !profileData.isPro ? styles.blur : ''} ${this.state.chartToDisplay === 'victoryMargin' ? 'd-block w-100' : 'd-none'} auto-scroll`}>
                                                {stats?.victoryMarginChart && (
                                                    <div className={`${styles.chart}`}>
                                                        <Bubble
                                                            data={canvas => this.getVictoryMarginChartData(canvas)}
                                                            options={this.getVictoryMarginChartOptions()}
                                                            width={1200}
                                                            height={440}
                                                            ref={this.setVictoryMarginChartRef}
                                                        />
                                                    </div>
                                                )}
                                                {!stats?.victoryMarginChart && (
                                                    <div className="text-center mt48" data-testid="profile.stats.victory-margin-empty-msg">
                                                        Not enough results to display the chart
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </React.Fragment>
                                }
                            </React.Fragment>
                        )}

                        {!isActivityMetricsEnabled && !isLoading && stats && stats.title === null && (
                            <div className="row mt64">
                                <div className="col-12">
                                    <p className="text-center" data-testid="profile.stats.no-metrics-msg">Player metrics are not available because player does not have enough match results.</p>
                                </div>
                            </div>
                        )}

                        {this.props.statsState.type === gameTypes.SINGLES && (
                            <React.Fragment>
                                <div className={`title mt60 mb24 text-uppercase`} data-testid="profile.stats.history-title">
                                    Full Rating History
                                </div>
                                <div className={`${styles.section} ${!userIsPowered && !profileData.isPro ? styles.blur : ''} ${'p0 bg-transparent'}`} data-testid="profile.stats.blurred-section">
                                    {history.length > 0 && (
                                        <div>
                                            <div className={`row ${styles.historyHeader}`}>
                                                <div className="col-2" />
                                                <div className="col-5" data-testid="profile.stats.history-header-date">
                                                    Date
                                                </div>
                                                <div className="col-5" data-testid="profile.stats.history-header-rating">
                                                    {ratingTypes.tennis}
                                                </div>
                                            </div>
                                            {history.length < 6 && (
                                                <React.Fragment>
                                                    {history.map((item, index) => (
                                                        <div
                                                            className={`${styles.historyItem}`}
                                                            key={`history-item-${item.id}`}
                                                        >
                                                            <div className="row">
                                                                <div className="col-2">
                                                                    <Img
                                                                        className={styles.historyItemImage}
                                                                        src={'/img/v2/icons/icon-avatar-player.svg'}
                                                                    />
                                                                </div>
                                                                <div className="col-5">
                                                                    <div className={`${styles.historyItemDate}`} data-testid={`profile.stats.history-item-${item.id ?? index}.date`}>
                                                                        {moment(item.date).format('YYYY-MM-DD')}
                                                                    </div>
                                                                </div>
                                                                <div className="col-5">
                                                                    <div className={`${styles.historyItemRating}`} data-testid={`profile.stats.history-item-${item.id ?? index}.rating`}>
                                                                        {item.ratingDisplay}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </React.Fragment>
                                            )}
                                            {history.length > 5 && (
                                                <React.Fragment>
                                                    {this.state.items.map((item, index) => (
                                                        <div
                                                            className={`${styles.historyItem}`}
                                                            key={`history-item-${item.id}`}
                                                        >
                                                            <div className="row">
                                                                <div className="col-2">
                                                                    <Img
                                                                        className={styles.historyItemImage}
                                                                        src={'/img/v2/icons/icon-avatar-player.svg'}
                                                                    />
                                                                </div>
                                                                <div className="col-5">
                                                                    <div className={`${styles.historyItemDate}`} data-testid={`profile.stats.history-item-${item.id ?? index}.date`}>
                                                                        {moment(item.date).format('YYYY-MM-DD')}
                                                                    </div>
                                                                </div>
                                                                <div className="col-5">
                                                                    <div className={`${styles.historyItemRating}`} data-testid={`profile.stats.history-item-${item.id ?? index}.rating`}>
                                                                        {item.ratingDisplay}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                    <div className="mt32">
                                                        {this.state.hasMore && (
                                                            <a href="#" className="underline" onClick={() => { this.handleShowMore(true); }} data-testid="profile.stats.history-show-all-link">
                                                                Show all
                                                            </a>
                                                        )}
                                                        {!this.state.hasMore && (
                                                            <a href="#" className="underline" onClick={() => { this.handleShowMore(false); }} data-testid="profile.stats.history-show-less-link">
                                                                Show less
                                                            </a>
                                                        )}
                                                    </div>
                                                </React.Fragment>
                                            )}
                                        </div>
                                    )}
                                    {history.length === 0 && (
                                        <div className={`${styles.historyHeader} ${styles.noHistoryText}`} data-testid="profile.stats.no-history-msg">
                                            There is no ratings history for this player
                                        </div>
                                    )}
                                </div>
                            </React.Fragment>
                        )}
                    </TabContentBase>
                )}
                {isActivityMetricsEnabled && effectiveStatsView === statsViewTypes.ACTIVITY && (
                    <ActivityStats auth={auth} isOwnProfile={isOwnProfile} playerId={playerId} />
                )}
                {isPerformanceStatsEnabled && effectiveStatsView === statsViewTypes.PERFORMANCE && (
                    <PerformanceStats
                        auth={auth}
                        isOwnProfile={isOwnProfile}
                        playerId={playerId}
                        onViewAllResults={onViewAllResults}
                        data-testid="profile.performance-stats"
                    />
                )}
            </React.Fragment>
        );
    }
}

NewStatsTabContent.propTypes = {
    profileTabData: PropTypes.objectOf(PropTypes.any),
    rankings: PropTypes.objectOf(PropTypes.any).isRequired,
    isActivityMetricsEnabled: PropTypes.bool,
    showActivityNewBadge: PropTypes.bool,
    isPerformanceStatsEnabled: PropTypes.bool,
    showPerformanceNewBadge: PropTypes.bool,
    onViewAllResults: PropTypes.func,
    isOwnProfile: PropTypes.bool,
    initialStatsView: PropTypes.string,
    volumetricStats: PropTypes.shape({}),
};
NewStatsTabContent.defaultProps = {
    profileTabData: {},
    isActivityMetricsEnabled: false,
    showActivityNewBadge: false,
    isPerformanceStatsEnabled: false,
    showPerformanceNewBadge: false,
    onViewAllResults: null,
    isOwnProfile: false,
    initialStatsView: null,
    volumetricStats: null,
};
function mapDispatchToProps(dispatch) {
    return {
        getPlayerStats: () => dispatch(getStatsData()),
    };
}

function mapStateToProps({ profileTabData, profile }) {
    return { profileTabData, volumetricStats: profile.volumetricStats };
}

export default withAuth(connect(mapStateToProps, mapDispatchToProps)(NewStatsTabContent));
